/*
  Louru: "Täydennä työpisteesi" -pakettiosio (snippets/louru-workstation-bundle.liquid).
  Laskee paketin hinnan valittujen tarvikkeiden mukaan ja lisää koneen + tarvikkeet koriin yhdellä kertaa.
  Varsinainen alennus tulee Shopifyn automaattisesta alennuksesta "Työpistepaketti -10 %" (enintään 4 tarviketta),
  joten osiossa voi valita enintään neljä tarviketta ja säästö on 10 % niiden hinnasta.
  Kuuntelijat ovat document-tasolla, joten ne toimivat myös, kun teema päivittää tuotesivun osion (morph).
*/
(function () {
  if (window.__louruWsInit) return;
  window.__louruWsInit = true;

  const MAX_DISCOUNTED = 4;

  function money(cents) {
    return '€' + (Math.round(cents) / 100).toFixed(2).replace('.', ',');
  }

  function update(root) {
    const pct = Number(root.dataset.discount || 10) / 100;
    const pcPrice = Number(root.dataset.pcPrice || 0);
    const checked = [...root.querySelectorAll('.louru-ws__check:checked')];
    const prices = checked.map((c) => Number(c.dataset.price));
    const full = prices.reduce((s, p) => s + p, 0);
    const save = prices.reduce((s, p) => s + Math.round(p * pct), 0);

    root.querySelector('[data-ws-count]').textContent = String(checked.length);
    root.querySelector('[data-ws-total]').textContent = money(pcPrice + full - save);
    const saveEl = root.querySelector('[data-ws-save]');
    saveEl.hidden = save <= 0;
    saveEl.textContent = save > 0 ? 'Säästät ' + money(save) : '';
    const msg = root.querySelector('[data-ws-msg]');
    if (checked.length && checked.length <= MAX_DISCOUNTED) msg.hidden = true;
  }

  document.addEventListener('change', function (e) {
    const box = e.target.closest && e.target.closest('.louru-ws__check');
    if (!box) return;
    const root = box.closest('.louru-ws');
    const msg = root.querySelector('[data-ws-msg]');
    if (box.checked && root.querySelectorAll('.louru-ws__check:checked').length > MAX_DISCOUNTED) {
      box.checked = false;
      msg.textContent = 'Pakettialennus koskee enintään neljää tarviketta.';
      msg.hidden = false;
      return;
    }
    update(root);
  });

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest && e.target.closest('[data-ws-add]');
    if (!btn || btn.dataset.busy) return;
    const root = btn.closest('.louru-ws');
    const msg = root.querySelector('[data-ws-msg]');
    const checked = [...root.querySelectorAll('.louru-ws__check:checked')];
    if (!checked.length) {
      msg.textContent = 'Valitse vähintään yksi tarvike.';
      msg.hidden = false;
      return;
    }
    const items = [{ id: Number(root.dataset.pcVariant), quantity: 1 }].concat(
      checked.map((c) => ({ id: Number(c.dataset.variantId), quantity: 1 }))
    );
    const label = btn.textContent;
    btn.dataset.busy = '1';
    btn.textContent = 'Lisätään...';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || 'HTTP ' + res.status);
      }
      btn.textContent = '✓ Lisätty';
      // Ostoskorisivulla asiakas näkee heti automaattisen pakettialennuksen.
      window.location.href = root.dataset.cartUrl || '/cart';
    } catch (err) {
      msg.textContent = 'Lisäys ei onnistunut: ' + err.message;
      msg.hidden = false;
      btn.textContent = label;
      delete btn.dataset.busy;
    }
  });

  function initAll() {
    document.querySelectorAll('.louru-ws').forEach(update);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
